import React from "react";
import { Heading, Text } from "mondrian-react";

import InternalLink from "components/InternalLink";

export default function Card(props) {
  let iconsize = props.iconsize ? props.iconsize : "md";
  let icon = `cred-ProfileCard-icon mdn-Icon-${props.icon} mdn-Icon--${iconsize}`;
  return (
    <>
      <InternalLink
        className="cred-card"
        link={props?.link}
        onClick={props?.onClick}
        data-gtm-event-category={`minha-claro:meu-perfil"`}
        data-gtm-event-action="clique:card"
        data-gtm-event-label={props?.link}
        tabIndex={props?.tabIndex}
      >
        <div
          className={`cred-ProfileCard ${
            props.inverse ? "cred-ProfileCard--inverse" : ""
          }`}
        >
          <span className={icon} aria-hidden="true"></span>
          <div className="cred-ProfileCard-content">
            <Heading tag="h3" sm inverse={props.inverse}>
              {props.title}
            </Heading>
            <Text tag="div" body inverse={props.inverse}>
              {props.text ? (
                <Text body inverse={props.inverse}>{props.text}</Text>
              ) : null}
              {props.children}
            </Text>
            <div
              className={`mdn-Link mdn-Link--arrow ${
                props?.inverse ? "mdn-Link--inverse" : ""
              }`}
            >
              {props?.linktext ? (
                <>
                  <span
                    className="mdn-Link-anchor"
                    data-gtm-event-category={`minha-claro:meu-perfil"`}
                    data-gtm-event-action="clique:card-link"
                    data-gtm-event-label={props.link}
                  >
                    {props?.linktext}
                  </span>
                  <i className="mdn-Link-anchor-icon mdn-Icon-direita mdn-Icon--sm"></i>
                </>
              ) : null}
            </div>
          </div>
        </div>
      </InternalLink>
    </>
  );
}
